<template>
    <div class="row " style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-12">
            <div class="my-3 d-flex justify-content-start gap-3 align-items-center form-check checkbox-checked">
                <input class="form-check-input" id="required-Condiment" type="checkbox" value="" style="margin: 0;"
                    v-model="compState.required">
                <label class="form-check-label" for="required-Condiment" style="margin: 0;">Condiments required</label>
                <button class="btn btn-outline-primary emailbox" type="button" @click="onReOrder" style="margin: 0;">
                    <i class="fa fa-sort"></i> Reorder</button>
            </div>
            <div class="w-100 custom-scrollbar b-dash" style="height: 50dvh;">
                <div class=" nav-link" style="	user-select: none;">
                    <draggable v-model="compState.condimentsListMock" item-key="id" handle=".handle"
                        class="box-list-container">
                        <template #item="{ element: item }">
                            <transition-group name="list" tag="div">
                                <div class="text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-content-center align-items-center gap-2 handle"
                                    @click="onCondimentGroupClick(item)"
                                    :style="{ boxShadow: isInCondimentGroup(item) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }"
                                    style="grid-column: span 1 / span 1; height: 96px;">
                                    <img v-if="item?.appearance?.image" :src="item.appearance.image"
                                        alt="department image" class="object-fit-cover w-25 ratio1-1 border-0" />
                                    <h5 class=" text-dark">
                                        {{ item.name }}</h5>
                                </div>
                            </transition-group>
                        </template>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Condiment } from '@/store/management/productsStore';
import { condimentsListMock } from '@/store/management/staticCondimentStore';
import draggable from "vuedraggable";
const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const condimentData = productGroup.condiments
        compState.condimentList = condimentData.condimentList
        compState.required = condimentData.required
    }
})

const compState = reactive({
    required: false,
    condimentList: [] as Condiment[],
    condimentsListMock: condimentsListMock,
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const condimentData = productGroup.condiments
        compState.condimentList = condimentData.condimentList
        compState.required = condimentData.required
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        condiments: {
            condimentList: newVal.condimentList,
            required: newVal.required
        }
    })

}, { deep: true });

const onReOrder = () => {
    compState.condimentsListMock.sort((a, b) => {
        const aInGroup = isInCondimentGroup(a);
        const bInGroup = isInCondimentGroup(b);

        if (aInGroup && !bInGroup) {
            return -1;
        } else if (!aInGroup && bInGroup) {
            return 1;
        } else {
            return 0;
        }
    });
}

const onCondimentGroupClick = (condimentGroup: Condiment) => {
    if (compState.condimentList.includes(condimentGroup)) {
        compState.condimentList = compState.condimentList.filter(group => group !== condimentGroup);
    } else {
        compState.condimentList.push(condimentGroup);
    }
}

const isInCondimentGroup = (condimentGroup: Condiment) => {
    return compState.condimentList.includes(condimentGroup);
}

</script>

<style scoped lang="scss">
.box-list-container {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>